import { BaseRestResource } from "src/app/infrastructure/BaseRestResource";
import httpResource from "src/app/modules/core/infrastructure/httpResource";

class StickerResource extends BaseRestResource {
    constructor() {
        super(httpResource, 'v2/stickers');
    }
}

const stickerResource = new StickerResource();

export default stickerResource;
